import React from "react";

const Icon_2 = () => {
  return (
    <>
    <svg width="190" height="121" viewBox="0 0 190 121" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_3282_20533)">
<g filter="url(#filter0_i_3282_20533)">
<rect width="190" height="190" rx="91.3462" fill="url(#paint0_linear_3282_20533)"/>
<g clipPath="url(#clip1_3282_20533)">
<rect width="14.6218" height="79.4751" rx="7.31091" transform="matrix(-0.374607 -0.927184 -0.927184 0.374607 170.119 81.828)" fill="#6EB0A9"/>
<rect width="13.7041" height="13.7041" rx="6.85207" transform="matrix(-0.374607 -0.927184 -0.927184 0.374607 109.84 105.706)" fill="#080E14"/>
<rect width="6.39322" height="6.39322" rx="3.19661" transform="matrix(-0.374607 -0.927184 -0.927184 0.374607 105.08 103.688)" fill="#6EB0A9"/>
</g>
</g>
</g>
<defs>
<filter id="filter0_i_3282_20533" x="0" y="0" width="190" height="190" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1.82692"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.811765 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 0.15 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow_3282_20533"/>
</filter>
<linearGradient id="paint0_linear_3282_20533" x1="95" y1="0" x2="95" y2="190" gradientUnits="userSpaceOnUse">
<stop stopColor="#17242F"/>
<stop offset="0.585" stopColor="#040D18" stopOpacity="0"/>
</linearGradient>
<clipPath id="clip0_3282_20533">
<rect width="190" height="121" fill="white"/>
</clipPath>
<clipPath id="clip1_3282_20533">
<rect width="14.6218" height="79.4751" rx="7.31091" transform="matrix(-0.374607 -0.927184 -0.927184 0.374607 170.119 81.828)" fill="white"/>
</clipPath>
</defs>
</svg>
    </>
  );
};

export default Icon_2;
